import "./css/grid.css";
import { NavLink, Link } from "react-router-dom";
import styled from "styled-components";
import Modal from "./Modal";
import React, { useState, useEffect } from "react";
import Pagination from "./Pagination";
import axios from "axios";
import SubHeader from "../components/subHeader3";

const PRcenter = () => {
  const [isPage, setIsPage] = useState(false);
  const [limit, setLimit] = useState(9);
  const [page, setPage] = useState(1);

  const [isEmpty, setEmpty] = useState(false);

  const offset = (page - 1) * limit;
  const [data, setData] = useState([]);
  const [filterData, setfilterData] = useState([]);
  const [isloggedIn, setLoggedIn] = useState(false);
  const [search, setSearch] = useState(null);
  const [options, setOption] = useState("subject");
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    axios.get("https://thegmmedical.com:5002/api/pr").then((response) => {
      setData(response.data);
      setfilterData(response.data);
      if (response.data.length === 0) {
        setEmpty(true);
        console.log(response.data);
      } else {
        console.log("haha");
        setEmpty(false);
        if (response.data.length <= 9) {
          setIsPage(false);
        } else {
          setIsPage(true);
        }
      }
    });
    fetch("https://thegmmedical.com:5002/check", {
      method: "get", // 통신방법
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.message === "user존재") {
          setLoggedIn(true);
        }
      })
      .catch(() => {});
  }, []);
  function GetData() {
    const item = Object.values(data).map((item) => (
      <tr>
        <td className="m_dp_n">{item.board_id}</td>
        <td className="m_dp_n"></td>
        <td className="ta_l">
          <a className="bl_link" href="/board/view">
            {item.subject}
          </a>
        </td>
        <td>{item.board_date}</td>
      </tr>
    ));

    return item;
  }

  const item = GetData();

  return (
    <div className="wrapper">
      <SubHeader />
      <div className="">
        <h1 className="headerText">홍보자료</h1>
        <div className="board_wrapper">
          <Modal open={modalOpen} close={closeModal} header="이미지/동영상">
            <div
              style={{
                backgroundColor: "#eee",
                width: "100%",
                margin: "50px auto",
                height: "300px",
              }}
            >
              이미지/동영상
            </div>
          </Modal>
          <div className="grid_layout" style={{ padding: "0" }}>
            {isEmpty && (
              <tr style={{ textAlign: "center" }}>
                <td colSpan={4}>게시물이 없습니다.</td>
              </tr>
            )}
            {filterData
              .slice(offset, offset + limit)
              .map(
                ({
                  board_id,
                  subject,
                  board_date,
                  image_link,
                  content_txt,
                }) => (
                  <a className="grid" href={`/pr/view/${board_id}`} key={board_id}>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={image_link} alt={subject}></img>
                      </div>
                      <div className="gridTxt">
                        <span>{subject}</span>
                      </div>
                    </div>
                  </a>
                )
              )}
          </div>

          {isloggedIn && (
            <Link to="write">
              <div
                style={{
                  padding: "10px 30px",
                  marginTop: "20px",
                  width: "120px",
                  backgroundColor: "#555",
                  color: "white",
                  textAlign: "center",
                  display: "block",
                  cursor: "pointer",
                }}
              >
                글쓰기
              </div>
            </Link>
          )}
          {isPage && (
            <div className="paging">
              <Pagination
                postsPerPage={limit}
                totalPosts={filterData.length}
                page={page}
                paginate={setPage}
              ></Pagination>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PRcenter;
